import React, { useState, useRef, useEffect } from 'react'
import useViewport from '@aytm/app/swidget/base/modules/viewport/useViewport.ts'
import useOnClickOutside from '@aytm/lib/hooks/useOnClickOutside'
import { hapticEffects } from '@aytm/app/swidget/base/lib/hapticEffects'
import style from './AddToCartButton.module.scss'

export interface IAddToCartButtonProps {
  index: number
  amount: number
  defaultLabel: string
  showIcon: boolean
  collapsible: boolean
  findability: boolean
  limit?: number
  width?: string
  skin?: 'default' | 'transparent'
  onAddToCart: (qnt: 1 | -1, index: number) => void
}

const AddToCartButton = ({
  index,
  amount,
  defaultLabel,
  showIcon,
  width,
  collapsible,
  findability,
  limit,
  skin = 'default',
  onAddToCart
}: IAddToCartButtonProps) => {
  const viewport = useViewport()
  const [focused, setFocused] = useState<boolean>(false)
  const spinButtonRef = useRef<HTMLDivElement>(null)
  const buttonContainerRef = useRef<HTMLDivElement>(null)

  const adjustAmount = (event: React.MouseEvent) => {
    event.stopPropagation()
    hapticEffects.selection()
    const qnt = Number((event.target as HTMLElement).dataset.quantity) as 1 | -1
    if (!isNaN(qnt)) onAddToCart(qnt, index)
  }

  useOnClickOutside(buttonContainerRef, () => {
    setFocused(false)
  })

  useEffect(() => {
    if (spinButtonRef.current && focused && collapsible) {
      spinButtonRef.current.focus()
    }
  }, [focused, collapsible])
  return (
    <div
      ref={buttonContainerRef}
      data-testid="SW-EC-AddToCartButton"
      className={`${style.button} ${viewport.mobile ? style.buttonMobile : ''}`}
    >
      {0 === amount || findability ? (
        <button
          disabled={findability && 1 === amount}
          className={`${style.default} ${'transparent' === skin ? style.defaultTransparent : ''}`}
          style={{ width: width }}
          onClick={event => {
            event.stopPropagation()
            hapticEffects.selection()
            onAddToCart(1, index)
            setFocused(true)
          }}
        >
          {showIcon && <i className="wm-Plus" />}
          <span>{defaultLabel}</span>
        </button>
      ) : focused || !collapsible ? (
        <div
          style={{ width: width }}
          ref={spinButtonRef}
          className={`${style.spin} ${'transparent' === skin ? style.spinTransparent : ''}`}
          tabIndex={0}
          role="spinbutton"
          onClick={adjustAmount}
          onBlur={collapsible ? () => setFocused(false) : null}
        >
          <div className={style.justify}>
            <i className="wm-Minus" data-quantity="-1" />
          </div>
          <span className={style.amount}>{limit && amount >= limit ? `Max ${limit}` : amount}</span>
          <div className={`${style.justify} ${limit && amount >= limit ? style.disabled : ''}`}>
            <i className="wm-Plus" data-quantity="1" />
          </div>
        </div>
      ) : (
        <button
          className={style.single}
          onClick={event => {
            event.stopPropagation()
            hapticEffects.selection()
            setFocused(true)
          }}
        >
          {amount}
        </button>
      )}
    </div>
  )
}

export default AddToCartButton
